var render = function () {
  var _this = this;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report-step', {
    attrs: {
      "md": _vm.md,
      "isDone": this.valid,
      "title": _vm.header.title,
      "description": _vm.header.description,
      "debug": [_vm.numberplate, _vm.user, _vm.contact, _vm.address],
      "showFooter": false
    }
  }, [_c('v-card', {
    staticClass: "pl-4 pr-4",
    attrs: {
      "flat": "",
      "max-width": "1200"
    }
  }, [!_vm.isAuthenticated ? _c('v-form', {
    ref: "form",
    model: {
      value: _vm.valid,
      callback: function callback($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: _vm.isCompany,
      callback: function callback($$v) {
        _vm.isCompany = $$v;
      },
      expression: "isCompany"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('report.thgContactData.private'),
      "value": false,
      "data-test-form-isprivate": ""
    }
  }), _c('v-radio', {
    attrs: {
      "label": _vm.$t('report.thgContactData.corporateClient'),
      "value": true,
      "data-test-form-iscompany": ""
    }
  })], 1), _vm.isCompany ? _c('v-text-field', {
    attrs: {
      "value": _vm.company,
      "label": _vm.$t('report.thgContactData.companyName'),
      "rules": [function (v) {
        return !!v || 'Eingabe ist erforderlich';
      }],
      "required": "",
      "outlined": "",
      "data-test-form-company": ""
    },
    on: {
      "blur": _vm.updateCompany
    }
  }) : _vm._e(), _c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("report.thgContactData.generalTitle")))]), _c('v-text-field', {
    attrs: {
      "value": _vm.numberplate,
      "label": _vm.$t('report.thgContactData.numberplate'),
      "hint": _vm.$t('report.thgContactData.numberplateHint'),
      "rules": _vm.numberPlateRules,
      "required": "",
      "outlined": "",
      "data-test-form-numberplate": ""
    },
    on: {
      "blur": _vm.updateNumberplate
    }
  }), _c('v-text-field', {
    attrs: {
      "value": _vm.user.firstName,
      "label": _vm.$t('report.thgContactData.firstName'),
      "rules": _vm.noNumberRule,
      "required": "",
      "outlined": "",
      "data-test-form-firstName": ""
    },
    on: {
      "blur": _vm.updateUserFirstName
    }
  }), _c('v-text-field', {
    attrs: {
      "value": _vm.user.lastName,
      "label": _vm.$t('report.thgContactData.lastName'),
      "rules": _vm.noNumberRule,
      "required": "",
      "outlined": "",
      "data-test-form-lastName": ""
    },
    on: {
      "blur": _vm.updateUserLastName
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('report.thgContactData.mail'),
      "value": _vm.contact.email,
      "type": "email",
      "rules": _vm.emailRules,
      "autocomplete": "email",
      "required": "",
      "outlined": "",
      "data-test-form-email": ""
    },
    on: {
      "blur": _vm.updateUserEmail
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('report.thgContactData.phone'),
      "value": _vm.contact.phone,
      "type": "tel",
      "rules": _vm.phoneNumberRules,
      "required": "",
      "outlined": "",
      "data-test-form-phone": ""
    },
    on: {
      "blur": _vm.updateUserPhone
    }
  }), _c('span', [_c('v-card-title', [_vm._v(_vm._s(_vm.$t("report.thgContactData.addressDetailsTitle")))]), _c('v-card-text', [_vm._v(" " + _vm._s(_vm.$t("report.thgContactData.addressDetailsDescription")) + " ")]), _c('v-radio-group', {
    staticClass: "mb-2",
    attrs: {
      "row": ""
    },
    model: {
      value: _vm.isResubmitAddress,
      callback: function callback($$v) {
        _vm.isResubmitAddress = $$v;
      },
      expression: "isResubmitAddress"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('report.thgContactData.register'),
      "value": false,
      "data-test-form-isNotResubmittingAddressDetails": ""
    }
  }), _c('v-radio', {
    attrs: {
      "label": _vm.$t('report.thgContactData.resubmit'),
      "value": true,
      "data-test-form-isResubmittingAddressDetails": ""
    }
  })], 1), !_vm.isResubmitAddress ? _c('v-text-field', {
    attrs: {
      "label": _vm.$t('report.thgContactData.street'),
      "value": _vm.address.street,
      "required": "",
      "outlined": "",
      "data-test-form-street": ""
    },
    on: {
      "blur": _vm.updateUserStreet
    }
  }) : _vm._e(), !_vm.isResubmitAddress ? _c('v-text-field', {
    attrs: {
      "label": _vm.$t('report.thgContactData.zip'),
      "type": "number",
      "value": _vm.address.zip,
      "min": "0",
      "rules": _vm.zipRules,
      "required": "",
      "outlined": "",
      "data-test-form-zip": ""
    },
    on: {
      "blur": _vm.updateUserZip
    }
  }) : _vm._e(), !_vm.isResubmitAddress ? _c('v-text-field', {
    attrs: {
      "label": _vm.$t('report.thgContactData.city'),
      "value": _vm.address.city,
      "required": "",
      "outlined": "",
      "data-test-form-city": ""
    },
    on: {
      "blur": _vm.updateUserCity
    }
  }) : _vm._e()], 1), _vm.showBankingInfo ? _c('span', [_c('v-card-title', [_vm._v(_vm._s(_vm.$t("report.thgContactData.bankDetailsTitle")))]), _c('v-card-text', [_vm._v(" " + _vm._s(_vm.$t("report.thgContactData.bankDetailsDescription")) + " ")]), _c('v-radio-group', {
    staticClass: "mb-2",
    attrs: {
      "row": ""
    },
    model: {
      value: _vm.isResubmittingBankingData,
      callback: function callback($$v) {
        _vm.isResubmittingBankingData = $$v;
      },
      expression: "isResubmittingBankingData"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('report.thgContactData.register'),
      "value": false,
      "data-test-form-isNotResubmittingBankingData": ""
    }
  }), _c('v-radio', {
    attrs: {
      "label": _vm.$t('report.thgContactData.resubmit'),
      "value": true,
      "data-test-form-isResubmittingBankingData": ""
    }
  })], 1), !_vm.isResubmittingBankingData ? _c('v-text-field', {
    attrs: {
      "label": _vm.$t('report.thgContactData.accountHolder'),
      "value": _vm.banking.name,
      "rules": [function (v) {
        return !!v || _this.$t('report.thgContactData.mandatoryInput');
      }],
      "required": "",
      "outlined": "",
      "data-test-form-banking-name": ""
    },
    on: {
      "blur": _vm.updateBankingName
    }
  }) : _vm._e(), !_vm.isResubmittingBankingData ? _c('v-text-field', {
    attrs: {
      "label": _vm.$t('report.thgContactData.iban'),
      "value": _vm.banking.iban,
      "rules": _vm.ibanRules,
      "required": "",
      "outlined": "",
      "data-test-form-banking-iban": ""
    },
    on: {
      "blur": _vm.updateBankingIban
    }
  }) : _vm._e(), !_vm.isResubmittingBankingData ? _c('v-text-field', {
    attrs: {
      "label": _vm.$t('report.thgContactData.bankingInstitution'),
      "value": _vm.banking.bank,
      "rules": [function (v) {
        return !!v || _this.$t('report.thgContactData.mandatoryInput');
      }],
      "required": "",
      "outlined": "",
      "data-test-form-banking-bank": ""
    },
    on: {
      "blur": _vm.updateBankingBank
    }
  }) : _vm._e(), _vm.isCompany ? _c('span', [_c('v-card-title', [_vm._v(_vm._s(_vm.$t("report.thgContactData.taxnumberTitle")))]), _c('v-card-text', [_vm._v(" " + _vm._s(_vm.$t("report.thgContactData.taxnumberDescription")) + " ")]), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: _vm.isResubmittingTaxnumber,
      callback: function callback($$v) {
        _vm.isResubmittingTaxnumber = $$v;
      },
      expression: "isResubmittingTaxnumber"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('report.thgContactData.register'),
      "value": false,
      "data-test-form-isNotResubmittingTaxnumber": ""
    }
  }), _c('v-radio', {
    attrs: {
      "label": _vm.$t('report.thgContactData.resubmit'),
      "value": true,
      "data-test-form-isResubmittingTaxnumber": ""
    }
  })], 1), !_vm.isResubmittingTaxnumber ? _c('v-text-field', {
    attrs: {
      "value": _vm.taxnumber,
      "label": _vm.$t('report.thgContactData.taxnumber'),
      "rules": [function (v) {
        return !!v || _this.$t('report.thgContactData.mandatoryInput');
      }],
      "required": "",
      "outlined": "",
      "data-test-form-taxnumber": ""
    },
    on: {
      "blur": _vm.updateTaxnumber
    }
  }) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()], 1) : _c('v-form', {
    ref: "form",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.goNextScreen.apply(null, arguments);
      }
    },
    model: {
      value: _vm.valid,
      callback: function callback($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.numberplate,
      "label": _vm.$t('report.thgContactData.numberplate'),
      "hint": _vm.$t('report.thgContactData.numberplateHint'),
      "rules": _vm.numberPlateRules,
      "required": "",
      "outlined": "",
      "data-test-form-numberplate": ""
    },
    on: {
      "blur": _vm.updateNumberplate
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }